import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { BackArrowIcon } from "../../../Assets/Icons";
import { UiComponents } from "@simulanisindia/ui";
import SelectType from "../NewSubscription/SelectType";
import ResourceSection from "../NewSubscription/ResourceSection";
import {
  PLAN_DETAIL_TAB,
  RESOURCE_APPLICATION_TAB,
  RESOURCE_ENVIRONMENT_TAB,
  RESOURCE_MODULE_TAB,
  RESOURCE_SKILL_SCHOOL_TAB,
  RESOURCE_SKILL_STREAM_TAB,
  VALIDITY_TAB,
} from "../../../Constant/constant";
import apiClient from "../../../apiClient";
import { SSO_URL } from "../../../env";
import { CREATE_NEW_SUBSCRIPTION } from "../../../apiClient/apiEndpoints";

const { BackButton } = UiComponents;

const tabText = {
  [RESOURCE_ENVIRONMENT_TAB]: "Validity",
  [RESOURCE_MODULE_TAB]: "Validity",
  [RESOURCE_SKILL_SCHOOL_TAB]: "Validity",
  [RESOURCE_SKILL_STREAM_TAB]: "Validity",
  [RESOURCE_APPLICATION_TAB]: "Validity",
  [VALIDITY_TAB]: "Plan Details",
  [PLAN_DETAIL_TAB]: "Submit",
};
const nextTab = {
  [RESOURCE_APPLICATION_TAB]: VALIDITY_TAB,
  [RESOURCE_MODULE_TAB]: VALIDITY_TAB,
  [RESOURCE_SKILL_SCHOOL_TAB]: VALIDITY_TAB,
  [RESOURCE_SKILL_STREAM_TAB]: VALIDITY_TAB,
  [RESOURCE_ENVIRONMENT_TAB]: VALIDITY_TAB,

  [VALIDITY_TAB]: PLAN_DETAIL_TAB,
  [PLAN_DETAIL_TAB]: "Submit",
};

const CreateNewSubscription = () => {
  const { checkedApplication, checkedResource, amount, invoice, planType, entityType, reminder, newsletter, saleType, useCaseTgs } = useSelector(
    (state) => state.subscriptionSlice
  );
  const navigate = useNavigate();
  const params = useParams();
  const { id } = params;
  const [activeTab, setActiveTab] = useState(RESOURCE_APPLICATION_TAB);
  const [buttonLabel, setButtonLabel] = useState("");
  const [error, setError] = useState(null);

  const backClick = () => navigate(-1);

  useEffect(() => {
    setButtonLabel(tabText[activeTab]);
  }, [activeTab]);

  const validation = () => {
    let errorStatus = false;
    let allDates = [...checkedApplication, ...checkedResource].map(item => item.dates[1]);

    if (useCaseTgs.length === 0) {
      errorStatus = true;
      setError("select useCase application.");
    }

    if (!saleType) {
      errorStatus = true;
      setError("select sale Type.");
    }

    if (allDates.length === 0 || !allDates.every(e => e)) {
      errorStatus = true;
      setError("select date of every application and resource");
    }

    return errorStatus
  }

  const handleCreateSubscription = async () => {
    setError(null);

    try {

      if (validation()) return;
      let bodyData = {
        applications: checkedApplication.map((item) => ({ id: item.id, dates: item.dates, amount: item?.amount || 0 })),
        resources: checkedResource.map((item) => ({ id: item.id, dates: item.dates })),
        amount: amount || 0,
        invoice: invoice,
        planType: planType,
        entityType: entityType,
        reminder: reminder,
        newsletter: newsletter,
        tags: [saleType.value, ...useCaseTgs.map(e => e.value)],
      };

      await apiClient.post(`${SSO_URL}${CREATE_NEW_SUBSCRIPTION}/${id}`, bodyData);

    } catch (error) {
      console.log(error);
    }
  };

  const handleButtonClick = () => {
    if (activeTab === PLAN_DETAIL_TAB) {
      handleCreateSubscription();
      return;
    }
    setActiveTab(nextTab[activeTab]);
  };

  return (
    <div className="create-new-subscription">
      <div className="page-title justify-content-between" style={{ border: "none" }}>
        <div className="title-back">
          <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
          <h6>New Subscription </h6>
        </div>

        <div>
          <button className={`normalbtn ${error ? "createSubsError" : ""}`} onClick={handleButtonClick}>
            {buttonLabel}
          </button>
        </div>
      </div>

      <div className="subscription-body">
        <SelectType activeTab={activeTab} setActiveTab={setActiveTab} setButtonLabel={setButtonLabel} />

        <div className="subscription-detail">
          <ResourceSection activeTab={activeTab} error={error} />
        </div>
      </div>
    </div>
  );
};

export default CreateNewSubscription;
